import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';

export default memo(function LogoutButton(props) {
    const { t } = useTranslation('auth');
    const logout = () => props.logOut(props.isAdmin, props.history);

    return (
        <Button variant="contained" onClick={logout}>
            {t('SKIP_TO_LOGIN')}
        </Button>
    );
}, (prevProps, nextProps) => prevProps.isAdmin === nextProps.isAdmin);
